import React from 'react';
import { Box, Icon } from '@honda-canada/design-system-react';
import themeStyles from './styles/Shared.styles';
const LoaderIconContainer = themeStyles.apply(Box, 'LoaderIconContainer');
const Loader = () => (React.createElement(LoaderIconContainer, { "data-testid": "loading" },
    React.createElement(Icon, { name: "animated360Loader" })));
export default Loader;
